<template>
  <div>
    <v-dialog scrollable max-width="1400px" v-model="model" persistent>
      <material-card
        :title="
          $t(
            'components.plan_benefit_rules.import_benefit_rules_configuration_dialog.import_benefit_rules'
          )
        "
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-expansion-panels accordion focusable multiple v-model="panels">
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <span>
                        {{
                          $t(
                            "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.choose_plan_and_effective_date"
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row justify-center>
                    <v-col xs="12" sm="6" md="6" lg="6">
                      <v-autocomplete
                        :clearable="true"
                        :label="
                          $t(
                            'globals.plan'
                          )
                        "
                        v-model="selected.Plan"
                        clear-icon="clear"
                        :items="plans"
                        :item-text="planDescription"
                        return-object
                        :rules="[$rules.required]"
                        class="required"
                      ></v-autocomplete>
                    </v-col>
                    <v-col xs="12" sm="6" md="6" lg="6">
                      <pbas-date-picker
                        class="required"
                        :value="selected.EffectiveDate"
                        @update-date="selected.EffectiveDate = $event"
                        :label="$t('components.inmemorydependants.effective_date')"
                        :rules="[$rules.required]"
                      ></pbas-date-picker>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="v-card__title">
                  <div class="row no-gutters">
                    <div class="col">
                      <span>
                        {{
                          $t(
                            "components.plan_benefit_rules.import_benefit_rules_configuration_dialog.configure_benefit_rules"
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="selected.Plan">
                  <plan-benefit-rules-files-table
                    ref="table"
                    @update="updateRules"
                    :planIdentityId="selected.Plan.PlanIdentityId"
                    :memberGroups="memberGroups"
                    :ruleTypes="ruleTypes"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
          <v-alert
            v-for="(error, i) in errors"
            dense
            type="error"
            :key="i"
            dismissible
          >
            {{ $t(error) }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $emit('close');
              item = null;
            "
            :loading="saving"
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid || errors.length > 0 || unusedGroups().length > 0"
            :loading="saving"
          >
            {{ $t("globals.import") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import { translate } from "@/trans";
import { translate2 } from "@/trans2";

import PlanBenefitRulesFilesTable from "@/components/PlanBenefitsRules/PlanBenefitRulesFilesTable.vue";
export default {
  props: ["model", "plans", "ruleTypes"],
  components: {
    ErrorHandler,
    PlanBenefitRulesFilesTable,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      errors: [],
      selected: {},

      panels: [0, 1, 2],

      // dentalGuidesPerProvince: {},
      // rules: {
      //   atLeastOneDental: (v) => {
      //     for (let province of Object.keys(this.dentalGuidesPerProvince)) {
      //       console.log(this.dentalGuidesPerProvince[province]);
      //       if (
      //         this.dentalGuidesPerProvince[province] !== null &&
      //         this.dentalGuidesPerProvince[province] !== undefined
      //       ) {
      //         return true;
      //       }
      //     }
      //     return this.$t(
      //       "validation.at_least_one_dental_guide_should_be_assigned"
      //     );
      //   },
      // },
      rules: {},
      memberGroups: [],
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.file = null;
          this.errors = [];
          this.selected = {
            PlanId: null,
            EffectiveDate: null,
            Files: [],
          };
          // this.dentalGuidesPerProvince = {};
        }
      },
    },
    "selected.Plan": {
      handler(v) {
        console.log(v);
        if (v !== null && v !== undefined) {
          this.loadMemberGroups();
          this.file = null;
          this.errors = [];
          this.selected.EffectiveDate = null;
          this.selected.Files = [];
          if (this.$refs.table) {
            this.$refs.table.clear();
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", [ "importPlanBenefitsRules"]),
    ...mapActions("plansMembers", ["getMemberGroups"]),
    planDescription(plan) {
      const desc = translate2(plan, "Name");
      if (desc.indexOf(plan.UniqueIdentifier) === 0) {
        return desc;
      }
      return plan.UniqueIdentifier + "-" + desc;
    },
    unusedGroups() {
      console.log(this.rules.items);
      if (this.rules.items === null || this.rules.items === undefined) {
        return this.memberGroups;
      }
      let usedGroups = this.rules.items
        .map((o) => {
          if (o.MemberGroups === null || o.MemberGroups === undefined) {
            return null;
          }
          return o.MemberGroups.map((oo) => oo.IdentityId);
        })
        .filter((o) => o !== null)
        .flat();
      console.log(usedGroups);
      let groups = this.memberGroups.filter(
        (o) => usedGroups.filter((oo) => oo === o.IdentityId).length === 0
      );
      console.log(groups);
      return groups;
    },
    async loadMemberGroups() {
      this.loading = true;
      try {
        this.memberGroups = (
          await this.getMemberGroups({
            plan: this.selected.Plan.PlanIdentityId,
            url: "?$expand=Translations",
          })
        ).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    translate(item, language) {
      return translate(item, language);
    },
    async save() {
      let item = JSON.parse(JSON.stringify(this.selected));
      item.PlanId = item.Plan.PlanIdentityId;
      delete item.Plan;
      // item.DentalGuides = [];
      // for (let provinceId of Object.keys(this.dentalGuidesPerProvince)) {
      //   item.DentalGuides.push({
      //     ProvinceId: provinceId,
      //     Guide: this.dentalGuidesPerProvince[provinceId],
      //   });
      // }
      // const files = [];
      // files.push(this.file);
      // if (this.fileGroupLimit) {
      //   files.push(this.fileGroupLimit);
      // }

      item.FileInfo = [];
      let files = [];
      let fileIndex = 0;
      for (const rule of this.rules.items) {
        console.log("--------------------", rule);
        let ruleFiles = this.rules.files.filter(
          (o) => o.Identifier === rule.Identifier
        )[0];
        console.log("-----22222222---------------", ruleFiles);
        let indices = [];
        if (ruleFiles !== null && ruleFiles !== undefined) {
          files.push(ruleFiles.File);
          indices.push(fileIndex);
          fileIndex++;

          if (
            ruleFiles.FileGroupLimit !== null &&
            ruleFiles.FileGroupLimit !== undefined
          ) {
            files.push(ruleFiles.FileGroupLimit);
            indices.push(fileIndex);
            fileIndex++;
          }
        }
        console.log("-----33333333---------------", files, fileIndex);
        if (indices.length > 0) {
          for (const group of rule.MemberGroups) {
            let fileInfo = {
              HealthLimitRules: rule.HealthLimitRules,
              DentalLimitRules: rule.DentalLimitRules,
              LimitRules: rule.LimitRules,
              MemberGroupIdentityId: group.IdentityId,
              RulesFileIndex: indices[0],
              ShowDentalBenefitBalance: rule.ShowDentalBenefitBalance,
              ShowHealthBenefitBalance: rule.ShowHealthBenefitBalance
            };
            if (indices.length > 1) {
              fileInfo.GroupRulesFileIndex = indices[1];
            }
            item.FileInfo.push(fileInfo);
          }
        }
      }
      delete item.Files;
      console.log(item);
      try {
        this.saving = true;
        await this.importPlanBenefitsRules({
          payload: JSON.stringify(item),
          files: files,
        });
        this.$emit("success");
      } catch (error) {
        // this.error = error;
        this.errors = [];
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 2800
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["2801"] !== null && errors["2801"] !== undefined) {
            for (const row of errors["2801"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2801_{0}_{1}", [
                  row.wrong_name,
                  row.correct_name,
                ])
              );
            }
          }
          if (errors["2802"] !== null && errors["2802"] !== undefined) {
            for (const row of errors["2802"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2802_{0}", [
                  row.row.toString(),
                ])
              );
            }
          }
          if (errors["2803"] !== null && errors["2803"] !== undefined) {
            for (const row of errors["2803"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2803_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["2804"] !== null && errors["2804"] !== undefined) {
            for (const row of errors["2804"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2804_{0}_{1}_{2}", [
                  row.row,
                  row.column,
                  row.correct_type,
                ])
              );
            }
          }
          if (errors["2805"] !== null && errors["2805"] !== undefined) {
            for (const row of errors["2805"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2805_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["2806"] !== null && errors["2806"] !== undefined) {
            for (const row of errors["2806"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2806_{0}", [
                  row.row.toString(),
                ])
              );
            }
          }
          console.log(this.errors);
        } else {
          this.error = error;
        }
      } finally {
        this.saving = false;
      }
    },
    updateRules(payload) {
      console.log("payload is: ", payload);
      this.rules = payload;
    },
  },
};
</script>

<style></style>
